import { useCallback } from 'react';
import { useOfficialStore } from '$/store/useOfficialStore';

// 仅供四个独立 AI 工具页上传入口使用：未登录时唤起登录，并阻断当前这次上传流程。
export async function ensureAiToolUploadLoginAsync() {
  const officialStore = useOfficialStore.getState();
  if (officialStore.isUserLoggedIn()) return true;

  try {
    await officialStore.toLogin();
  } catch (err) {
    console.error('AI tool upload login failed:', err);
    return false;
  }

  return useOfficialStore.getState().isUserLoggedIn();
}

// 给 ImageUploader.beforeOpen 使用的同步守卫；登录成功后用户需再次触发上传入口。
export function useAiToolUploadLoginGuard() {
  return useCallback(() => {
    const officialStore = useOfficialStore.getState();
    if (officialStore.isUserLoggedIn()) return true;

    officialStore.toLogin().catch(() => {});
    return false;
  }, []);
}
